import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import Field from './field';
import { observer } from 'mobx-react';

@observer
class GenericField extends Field {
	renderInput () {
		const {
			fieldKey,
			dataId,
			store,
			formStore,
			type,
			changeOnBlur,
			changeOnKeyUp,
			defaultValue,
			inputClass,
			placeholder,
			tabIndex,
			focusOnRender = false
		} = this.props;

		const addrs = {
			defaultValue,
			type,
			placeholder,
			tabIndex,
			id: fieldKey,
			name: fieldKey,
			'data-key': fieldKey,
			'data-ta': fieldKey,
			autoFocus: focusOnRender,
			autoComplete: 'off'
		};

		const {
			valueKey,
			setFilter
		} = formStore.get(fieldKey);

		const value = this.getValue({
			store,
			fieldKey,
			dataId,
			valueKey,
			setFilter
		});

		if (type === 'checkbox') {

			addrs.checked = _.isBoolean(value) ? value : defaultValue;
		} else if (value) {

			addrs.defaultValue = value;
		}

		if (changeOnBlur) {

			addrs.onBlur = this.handleChange;
		} else if (changeOnKeyUp) {

			// TODO: Confirm this is OK to add!
			// CONFIRMATION: It is okay if you use a prop to toggle this functionality on or off, with it being off by default
			// EXAMPLE: <Text changeOnKeyUp .../>
			addrs.onKeyUp = this.handleChange;
		} else {

			addrs.onChange = this.handleChange;
		}

		if (_.isString(inputClass)) {

			addrs.className = inputClass;
		}

		return (
			<Fragment>
				<input { ...addrs } />
			</Fragment>
		);
	}
}

function genericField (type, changeOnBlur = true, changeOnKeyUp = false) {
	return class extends Component {
		render () {
			return (
				<GenericField
					type={ type }
					changeOnBlur={ changeOnBlur }
					changeOnKeyUp={ changeOnKeyUp }
					{ ...this.props }
				/>
			);
		}
	}
}

export default genericField;
